import { ref } from 'vue';
import { getRemainingTime } from './get-remaining-time';

export default function useTimer(onTimerExpired: () => void) {
  const state = ref({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });
  const isExpired = ref(false);
  let intervalId: ReturnType<typeof setInterval>;

  function launchTimer(timeLimit: string) {
    const tick = () => {
      state.value = getRemainingTime(new Date(), timeLimit);
      if (state.value.milliseconds <= 0) {
        clearInterval(intervalId);
        isExpired.value = true;
        onTimerExpired();
      }
    };

    tick();
    if (state.value.milliseconds >= 1000) {
      intervalId = setInterval(tick, 1000);
    }
  }

  function clearTimer() {
    clearInterval(intervalId);
  }

  return {
    state,
    isExpired,
    launchTimer,
    clearTimer,
  };
}
